import React, { useState, useEffect } from 'react';
import Button from '@material-ui/core/Button';
import { policyItems } from './config';
import Checkbox from '@material-ui/core/Checkbox';
import Modal from '@/components/web/components/Modal';
import { InfluencerAgreement } from '@/components/campaign/influencerAgreement';
import { useWebModalStore } from '@/hooks/useWebModalStore';
import { isMobile } from '@/biz/tool';
import MobileSteps from './MobileSteps';
import BottomDrawer from '../BottomDrawer';
import { useTranslation } from 'react-i18next';

interface Props {
  step: number;
  setStep: Function;
  platform: string;
  maxStep: number;
  setMaxStep: Function;
}

const Policy: React.FC<Props> = ({
  step,
  setStep,
  platform,
  maxStep,
  setMaxStep
}) => {
  const [checkNum, setCheckNum] = useState(0);
  const { isShowAgreement, setIsShowAgreement } = useWebModalStore();
  const [items, setItems] = useState(policyItems);
  const { t } = useTranslation();

  useEffect(() => {
    const educationModalEnd = localStorage.getItem('educationModalEnd');
    if (!!educationModalEnd) {
      setCheckNum(items?.length);
      setItems([...policyItems]?.map((item) => ({ ...item, checked: true })));
    }
  }, []);

  useEffect(() => {
    setCheckNum(items?.filter((item: any) => item.checked)?.length);
  }, [step, items]);

  return (
    <div className={`w-full pb-8 bg-white ${isMobile() ? 'px-0' : 'px-8'}`}>
      <div className="w-full py-5 border-b border-[#e8e8ec] inline-flex flex-col justify-center items-start gap-2">
        <div className="justify-start text-[#1c2024] text-2xl font-semibold font-['Plus_Jakarta_Sans'] leading-normal">
          {t('education.policy.title', { defaultValue: 'Platform policy' })}
        </div>
        {isMobile() && <MobileSteps step={step} />}
        <div className="w-full justify-center text-[#60646c] text-sm font-normal font-['Inter'] leading-tight">
          {t('education.policy.subtitle', {
            defaultValue:
              'Understand the platform policy to protect your own rights'
          })}
        </div>
      </div>
      <div className="flex flex-col gap-4 mt-6">
        {items.map(
          (
            item: { title: string; des: string; checked: boolean },
            index: any
          ) => (
            <div
              key={item.title}
              className="self-stretch px-6 py-2 bg-[#f9f9fb] rounded-lg inline-flex justify-start items-center gap-4"
            >
              <Checkbox
                color="primary"
                onChange={(_, isSelect) => {
                  setCheckNum(checkNum + (isSelect ? 1 : -1));
                  const newItems = [...items];
                  newItems.forEach(
                    (v: { title: string; des: string; checked: boolean }) => {
                      if (v.title === item.title) {
                        v.checked = isSelect;
                      }
                    }
                  );
                  setItems(newItems);
                }}
                checked={!!item?.checked}
              />
              <div className="flex-1 inline-flex flex-col justify-start items-start gap-2">
                <div className="self-stretch justify-start text-[#1c2024] text-base font-semibold font-['Plus_Jakarta_Sans'] leading-normal">
                  {item?.title}
                </div>
                <div className="self-stretch justify-start text-[#60646c] text-sm font-medium font-['Plus_Jakarta_Sans'] leading-normal">
                  {item?.des}
                  {index === items.length - 1 && (
                    <span
                      className="text-[#0C67E6] cursor-pointer"
                      onClick={() => setIsShowAgreement(true)}
                    >
                      {t('education.policy.creator_agreement', {
                        defaultValue: 'Creator Agreement'
                      })}
                    </span>
                  )}
                </div>
              </div>
            </div>
          )
        )}
      </div>
      <div className="flex items-center justify-end gap-4 mt-8">
        <Button
          className="mui-btn-gray !w-[160px] !h-[40px]"
          onClick={() => {
            setStep(step - 1);
          }}
        >
          {t('common.back', { defaultValue: 'Back' })}
        </Button>
        <Button
          className="mui-btn-primary !w-[160px] !h-[40px]"
          onClick={() => {
            setStep(step + 1);
            setMaxStep(Math.max(maxStep, step + 1));
          }}
          disabled={checkNum < 6}
        >
          {t('common.next', { defaultValue: 'Next' })}
        </Button>
      </div>
      {isMobile() && (
        <BottomDrawer
          visible={isShowAgreement}
          isShowFooter={false}
          isShowHeader={false}
        >
          <InfluencerAgreement setIsShowAgreement={setIsShowAgreement} />
        </BottomDrawer>
      )}
      {!isMobile() && (
        <Modal
          visible={isShowAgreement}
          isShowFooter={false}
          isShowHeader={false}
        >
          <InfluencerAgreement setIsShowAgreement={setIsShowAgreement} />
        </Modal>
      )}
    </div>
  );
};

export default Policy;
